import React from 'react'

const AboutCustomers = () => {
    return (
        <div className="hardware-container">
          <div className="content">
            <h2 className="heading"><span>OUR CUSTOMERS</span></h2>
            <p className="description">Always provide better solution our customers</p>
    
            <div className="horizontal-text-container">
              <p>About Us</p>
              <p>/</p>
              <p>Our Customers
              </p>
            </div>
          </div>
        </div>
      )
    }
export default AboutCustomers